export default __webpack_public_path__ + "static/media/384.bf73fe1b.png";